"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonScoreboard = void 0;
const React = require("react");
const BronsonScoreboard = (props) => {
    const renderContent = () => {
        if (props.content && props.content.length) {
            let type = '';
            return props.content.map((elem, index) => {
                type = elem.type.toString();
                return (React.createElement("span", { key: index, className: `c-scoreboard__${type}` }, elem.value));
            });
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    return (React.createElement("p", { className: `c-scoreboard ${props.isDark ? 'c-scoreboard--dark' : ''}` }, renderContent()));
};
exports.BronsonScoreboard = BronsonScoreboard;
